import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

import { useTranslate } from '@growtherapy/i18n';
import { DrawerBody, DrawerHeader, IconButton, Subhead, cn } from '@growtherapy/sprout-ui';

import { useTheme } from '../../hooks/useTheme';
import { Theme } from '../../state/theme';

export function ReflectionTopicsDrawer({
  title,
  content,
  onClickBackButton,
}: {
  title: string;
  content: React.ReactNode;
  onClickBackButton?: () => void;
}) {
  const t = useTranslate();
  const { theme } = useTheme();
  const isDarkTheme = theme === Theme.DARK;

  return (
    <>
      <DrawerHeader>
        <div className='flex items-center'>
          {onClickBackButton && (
            <IconButton
              onClick={onClickBackButton}
              className='mr-4 w-8 h-8 flex justify-center items-center'
              iconSize='xs'
              aria-label={t('telehealth-core:core.goBack')}
              data-testid='reflection-topics.button.back'
              iconDefinition={faArrowLeft}
            />
          )}
          <Subhead.Small
            as='h3'
            className={cn({
              'rebrand:text-text-inverse': isDarkTheme,
            })}
          >
            {title}
          </Subhead.Small>
        </div>
      </DrawerHeader>
      <DrawerBody>{content}</DrawerBody>
    </>
  );
}
